// Libs
import { Rate } from 'antd';
import styled from 'styled-components';

const StyledRate = styled(Rate)``;

export default StyledRate;
